import {ReactNode, useEffect, useRef} from 'react';
import clsx from 'clsx';
import {useLocation} from 'react-router-dom';

export interface ContentGridProps {
  className?: string;
  children: ReactNode;
  variant?: 'portrait' | 'landscape';
  gridCols?: string;
}
export function ContentGridLayout({
  children,
  className,
  variant,
  gridCols = 'grid-cols-[repeat(var(--nVisibleItems),minmax(0,1fr))]',
}: ContentGridProps) {
  const ref = useRef<HTMLDivElement>(null);

  const pathname = useLocation().pathname;

  // useEffect(() => {
  //   if (pathname.includes("people")) {
  //     if (ref.current) {
  //       const currentHeight = ref.current.offsetHeight;
  //       ref.current.style.minHeight = `${currentHeight + 100}px`;
  //     }
  //   }
  // }, []);

  return (
    <div
      ref={ref}
      className={clsx(
        'grid min-h-[500px] gap-24 max-xl:min-h-[300px] max-lg:min-h-[200px] max-md:min-h-[300px]',
        gridCols,
        className,
        variant === 'landscape'
          ? 'content-grid-landscape'
          : 'content-grid-portrait',
      )}
    >
      {children}
    </div>
  );
}
